import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum DirectorySyncPermissionSet {
  View = 'directory_sync_view',
  Update = 'directory_sync_update',
  Sync = 'directory_sync_sync',
}

export const directorySyncPermissionSetGrouping: IPermissionSetGrouping<DirectorySyncPermissionSet> = {
  key: PermissionSetGroupingKey.DirectorySync,
  active: {
    [DirectorySyncPermissionSet.View]: [PermissionType.GET_ANY_DIRECTORY_SYNC_MAPPING],
    [DirectorySyncPermissionSet.Update]: [PermissionType.UPDATE_ANY_DIRECTORY_SYNC_MAPPING],
    [DirectorySyncPermissionSet.Sync]: [PermissionType.SYNC_ANY_DIRECTORY_MANUALLY],
  },
  unAssignablePermissionSets: [],
}
